<template>
  <div class="card dashboard-widget bot-performance-widget">
    <div class="card-header">FALLBACK RATE</div>
    <div class="card-body">
      <div class="chart-container">
        <GChart
          id="bot-performance-chart"
          class="g-chart"
          type="PieChart"
          :data="botPerformanceChartData"
          :options="chartOptions"
          :events="chartEvents"
        ></GChart>
        <div class="float-unit" v-if="botFallbackMessage && botFallbackMessage.length > 0">
          <div class="float-unit-content">
            <span>0</span>
            <span>100</span>
          </div>
        </div>
        <div class="float-value">{{botFallbackRate}}</div>
      </div>
      <div class="result-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Common fallback messages</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in botFallbackMessage" :key="message.message">
              <td class="message-text">{{message.message}}</td>
              <td>
                <span class="message-value">{{message.count}}</span>
                <span class="message-percent">({{message.portion}}%)</span>
              </td>
            </tr>
            <tr v-if="!botFallbackMessage || botFallbackMessage.length === 0">
              <td class="text-center no-data-text" colspan="2">
                Empty fallback message data ...
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="bottom-foot">Check Benchmark</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { GChart } from 'vue-google-charts';

export default {
  name: 'bot-performance-widget',
  components: {
    GChart,
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartOptions: {
        height: 160,
        chartArea: {
          top: 10,
        },
        colors: ['#ed5454', '#ddd'],
        legend: 'none',
        pieHole: 0.7,
        pieStartAngle: 270,
        pieSliceText: 'none',
        title: 'Fallback Rate',
        tooltip: {
          text: 'value',
        },
        slices: {
          2: {
            color: 'transparent',
          },
        },
        theme: 'maximized',
      },
      chartEvents: {
        ready: () => {
          // set width of label 0 - 100
          try {
            const chartWidth = document
              .querySelector('#bot-performance-chart g')
              .getBoundingClientRect().width;
            // console.log(chartWidth);
            document.querySelector('.float-unit-content').style.width = `${chartWidth}px`;
          } catch (e) {
            // console.log('Cannot get chart width');
          }
          if (document.querySelector('#bot-performance-chart text')) {
            if (document.querySelector('#bot-performance-chart text').innerHTML === 'No data') {
              document.querySelector('#bot-performance-chart text').style.opacity = '0.5';
            }
          }
        },
      },
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      loadBotPerformance: 'dashboard/loadBotPerformance',
    }),
    async init() {
      await this.loadBotPerformance({
        criteria: this.criteria,
      });
    },
  },
  computed: {
    ...mapGetters({
      botPerformanceData: 'dashboard/botPerformanceData',
    }),
    botPerformanceChartData() {
      const finalData = [['Name', 'Value']];
      if (this.botPerformanceData) {
        const { fallbackRate } = this.botPerformanceData;
        if (fallbackRate) {
          finalData.push(['Fallback Rate', { v: fallbackRate, f: `${fallbackRate}%` }]);
          const inverseValue = 100 - fallbackRate;
          finalData.push(['Accepted', { v: inverseValue, f: `${inverseValue}%` }]);
          finalData.push([null, 100]);
        }
      } else {
        finalData.push([null, 0]);
      }
      return finalData;
    },
    botFallbackRate() {
      let result = '';
      if (this.botPerformanceData) {
        const { fallbackRate } = this.botPerformanceData;
        if (fallbackRate) {
          result = `${fallbackRate.toFixed(0)}%`;
        }
      }
      return result;
    },
    botFallbackMessage() {
      let result = [];
      if (this.botPerformanceData) {
        const { fallbackMessage } = this.botPerformanceData;
        if (fallbackMessage) {
          result = fallbackMessage;
        }
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.bot-performance-widget {
  .card-body {
    padding: 0;
  }
  .chart-container {
    overflow: hidden;
    height: 130px;
    position: relative;
    .float-unit {
      position: absolute;
      width: 100%;
      bottom: 25px;
      font-size: 0.7rem;
      z-index: 10;
      color: #b9b9b9;
      display: flex;
      justify-content: center;
      .float-unit-content {
        padding-left: 8px;
        display: flex;
        justify-content: space-between;
      }
    }
    .float-value {
      position: absolute;
      bottom: 40px;
      font-size: 1.1rem;
      width: 100%;
      text-align: center;
      color: #666;
    }
  }
  .result-wrapper {
    max-height: 240px;
    min-height: 240px;
    overflow-y: auto;
    .table {
      th {
        position: sticky;
        top: -1px;
        right: -1px;
        background-color: #ed5454;
        border-bottom: none;
        font-size: 0.7rem;
        color: #fff;
      }
    }
  }
  .message-text {
    font-weight: 500;
    color: #555;
  }
  .message-value {
    color: #666;
    margin-right: 5px;
  }
  .message-percent {
    color: #aaaaaa;
    font-size: 0.65rem;
  }
  .bottom-foot {
    cursor: pointer;
    padding: 8px;
    font-size: 0.7rem;
    text-align: center;
    color: #888;
    border-top: 1px solid #ddd;
    background-color: #eee;
    &:hover {
      font-weight: 400;
    }
  }
  .no-data-text {
    font-size: 12px;
    color: #aaa;
    line-height: 42px;
  }
}
</style>
